import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  makeStyles,
  FormControlLabel,
  Switch,
  FormGroup,
  Typography,
  Divider,
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from '@material-ui/core';
import { i18n } from '../../translate/i18n';

const useStyles = makeStyles(theme => ({
  dialog: {
    padding: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(1),
  }
}));

const KanbanAutoMessageModal = ({ open, onClose, onSave, initialMessage, initialDelay, initialDelayUnit, initialKanban, initialInbox, initialFlowBuilder, initialCampaigns }) => {
  const classes = useStyles();
  const [message, setMessage] = useState('');
  const [delay, setDelay] = useState(10);
  const [kanban, setKanban] = useState(false);
  const [inbox, setInbox] = useState(false);
  const [flowBuilder, setFlowBuilder] = useState(false);
  const [campaigns, setCampaigns] = useState(false);
  const [delayUnit, setDelayUnit] = useState('seconds');

  useEffect(() => {
    if (open) {
      setMessage(initialMessage || '');
      setDelay(initialDelay !== undefined ? initialDelay : 10);
      setDelayUnit(initialDelayUnit || 'seconds');
      setKanban(initialKanban || false);
      setInbox(initialInbox || false);
      setFlowBuilder(initialFlowBuilder || false);
      setCampaigns(initialCampaigns || false);
    }
  }, [open, initialMessage, initialDelay, initialDelayUnit, initialKanban, initialInbox, initialFlowBuilder, initialCampaigns]);

  const handleSave = () => {
    onSave(message, delay, kanban, inbox, flowBuilder, campaigns, delayUnit);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className={classes.dialog}>
      <DialogTitle>{i18n.t("kanban.autoMessage.title")}</DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          margin="dense"
          label={i18n.t("kanban.autoMessage.messageLabel")}
          type="text"
          fullWidth
          multiline
          minRows={4}
          variant="outlined"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className={classes.textField}
        />
        <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
          <TextField
            margin="dense"
            label={i18n.t("kanban.autoMessage.delayLabel", "Intervalo Base")}
            type="number"
            style={{ flex: 2 }}
            variant="outlined"
            value={delay}
            onChange={(e) => setDelay(e.target.value)}
            onBlur={(e) => setDelay(Math.max(delayUnit === 'seconds' ? 10 : 1, parseInt(e.target.value) || (delayUnit === 'seconds' ? 10 : 1)))}
            className={classes.textField}
            helperText={i18n.t("kanban.autoMessage.delayHelper", "El sistema añadirá un retraso aleatorio entre 15 y 60 segs por seguridad.")}
            inputProps={{ min: delayUnit === 'seconds' ? 10 : 1 }}
          />
          <FormControl variant="outlined" margin="dense" style={{ flex: 1, marginTop: 8 }}>
            <InputLabel>{i18n.t("kanban.autoMessage.unitLabel", "Unidad")}</InputLabel>
            <Select
              value={delayUnit}
              onChange={(e) => {
                const newUnit = e.target.value;
                setDelayUnit(newUnit);
                if (newUnit !== 'seconds' && delay < 1) setDelay(1);
                if (newUnit === 'seconds' && delay < 10) setDelay(10);
              }}
              label={i18n.t("kanban.autoMessage.unitLabel", "Unidad")}
            >
              <MenuItem value="seconds">{i18n.t("kanban.autoMessage.units.seconds", "Segundos")}</MenuItem>
              <MenuItem value="minutes">{i18n.t("kanban.autoMessage.units.minutes", "Minutos")}</MenuItem>
              <MenuItem value="hours">{i18n.t("kanban.autoMessage.units.hours", "Horas")}</MenuItem>
              <MenuItem value="days">{i18n.t("kanban.autoMessage.units.days", "Días")}</MenuItem>
              <MenuItem value="months">{i18n.t("kanban.autoMessage.units.months", "Meses")}</MenuItem>
            </Select>
          </FormControl>
        </div>
        <Divider style={{ margin: '16px 0' }} />
        <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
          {i18n.t("kanban.autoMessage.originsTitle", "Orígenes de activación")}
        </Typography>
        <FormGroup row>
          <FormControlLabel
            control={<Switch checked={kanban} onChange={(e) => setKanban(e.target.checked)} name="kanban" color="primary" />}
            label={i18n.t("kanban.autoMessage.originKanban", "Kanban")}
          />
          <FormControlLabel
            control={<Switch checked={inbox} onChange={(e) => setInbox(e.target.checked)} name="inbox" color="primary" />}
            label={i18n.t("kanban.autoMessage.originInbox", "Inbox")}
          />
          <FormControlLabel
            control={<Switch checked={flowBuilder} onChange={(e) => setFlowBuilder(e.target.checked)} name="flowBuilder" color="primary" />}
            label={i18n.t("kanban.autoMessage.originFlowBuilder", "Flow Builder")}
          />
          <FormControlLabel
            control={<Switch checked={campaigns} onChange={(e) => setCampaigns(e.target.checked)} name="campaigns" color="primary" />}
            label={i18n.t("kanban.autoMessage.originCampaigns", "Campañas")}
          />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {i18n.t("kanban.autoMessage.cancel")}
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          {i18n.t("kanban.autoMessage.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KanbanAutoMessageModal;

